var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('h1',[_vm._v("Personal Access Tokens")]),_c(_setup.PATList,{attrs:{"email":_setup.email}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }